
// import React, { useEffect, useState } from 'react';
// import '../styles/CampusInfo.css';

// const LOCATIONS = [
//   {
//     type: "Registered Office",
//     address: "Plot No 5, Shri Gokul Society, Navi Peth, Sadashiv Peth, Pune, 411030.",
//     region: "Pune, India",
//     embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.504746764516!2d73.83605907519129!3d18.506124582586224!2m3!1f0!2f0!3f0!3m2!1i1024!2i1024!4f13.1!3m3!1m2!1s0x3bc2bff356029025%3A0x3554dbb532013f77!2sSkyLine%20Enterprises!5e0!3m2!1sen!2sin!4v1709756000000!5m2!1sen!2sin",
//     mapUrl: "https://www.google.com/maps?q=Sadashiv+Peth+Pune"
//   },
//   {
//     type: "Headquarters GTE ONE",
//     address: "Office #1401, S.No. 30, DNK SQUARE, Airport road, Sakore Nagar, Viman Nagar, Pune-411014.",
//     region: "Maharashtra, India",
//     embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.316819323363!2d73.90418237519266!3d18.557674182544327!2m3!1f0!2f0!3f0!3m2!1i1024!2i1024!4f13.1!3m3!1m2!1s0x3bc2c127fe3f730b%3A0x7fbe51543d7f950a!2sDNK%20SQUARE%20by%20Dugad%20Group!5e0!3m2!1sen!2sin!4v1709756100000!5m2!1sen!2sin",
//     mapUrl: "https://www.google.com/maps?q=DNK+SQUARE+Viman+Nagar+Pune"
//   },
//   {
//     type: "Shivajinagar",
//     address: "Sai Capital Building, 403, 4th Floor, Senapati Bapat Rd., Model Colony, Pune-411016.",
//     region: "Pune, India",
//     embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.0076231904797!2d73.82772437519195!3d18.52857418257008!2m3!1f0!2f0!3f0!3m2!1i1024!2i1024!4f13.1!3m3!1m2!1s0x3bc2bf79e0b51c63%3A0xa0467142e87ec11e!2sSai%20Capital!5e0!3m2!1sen!2sin!4v1709756200000!5m2!1sen!2sin",
//     mapUrl: "https://www.google.com/maps?q=Sai+Capital+Senapati+Bapat+Rd+Pune"
//   },
//   {
//     type: "USA",
//    address: `9498 SW Barbur Blvd.
// Suite 207, 2nd Floor
// Portland, OR 97219`,
//     region: "Oregon, USA",
//     embedUrl:
//       "https://maps.google.com/maps?q=9498%20SW%20Barbur%20Blvd%20Portland%20OR%2097219&z=15&output=embed",
//     mapUrl:
//       "https://www.google.com/maps/search/?api=1&query=9498+SW+Barbur+Blvd+Portland+OR+97219",
//   }
// ];

// const LocationCard = ({ loc }) => (
//   <div className="campus-card glass-morph">
//     <div className="card-header">
//       <h3 className="office-title">{loc.type}</h3>
//     </div>

//     <div className="map-embed-frame">
//       <iframe
//         src={loc.embedUrl}
//         width="100%"
//         height="200"
//         style={{ border: 0 }}
//         allowFullScreen=""
//         loading="lazy"
//         title={`Map for ${loc.type}`}
//       />
//     </div>

//     <div className="card-content">
//       <div className="address-box">
//         <span className="label">OFFICE ADDRESS:</span>
//         <p className="address-text">{loc.address}</p>
//       </div>

//       <div className="card-footer">
//         <span className="region-tag">{loc.region}</span>

//         <a
//           href={loc.mapUrl}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="location-btn"
//           style={{ textDecoration: 'none' }}
//         >
//           <span className="loc-icon">📍</span>
//           <span className="btn-text">NAVIGATE</span>
//         </a>
//       </div>
//     </div>
//   </div>
// );

// const CampusInfo = ({ userData }) => {

//   const [locations, setLocations] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {

//     const email =
//       userData?.EmailId ||
//       userData?.email ||
//       "";

//     const isGenesis = email
//       .toLowerCase()
//       .endsWith("genesistech.co.in");

//     console.log("Campus Email:", email);
//     console.log("Is Genesis:", isGenesis);

//     if (isGenesis) {
//       setLocations(LOCATIONS);
//       setLoading(false);
//       return;
//     }

//     fetch("/gt-api/get_company_locations.php", {
//       credentials: "include"
//     })
//       .then(res => res.json())
//       .then(data => {

//         console.log("Campus API:", data);

//         if (data.success) {

//           const formatted = (data.locations || []).map(loc => ({
//             type: loc.office_type,
//             address: loc.address,
//             region: loc.region,
//             embedUrl: loc.embed_url,
//             mapUrl: loc.map_url
//           }));

//           setLocations(formatted);
//         }
//       })
//       .catch(err => {
//         console.error("Campus Fetch Error:", err);
//       })
//       .finally(() => {
//         setLoading(false);
//       });

//   }, [userData]);

//   if (loading) {
//     return (
//       <div className="campus-container animate-fade">
//         <h3 style={{ textAlign: "center" }}>
//           Loading Campus Information...
//         </h3>
//       </div>
//     );
//   }

//   if (locations.length === 0) {
//     return (
//       <div className="campus-container animate-fade">
//         <div
//           style={{
//             textAlign: "center",
//             padding: "60px",
//             opacity: 0.7
//           }}
//         >
//           <h3>No Campus Information Available</h3>
//           <p>Please contact your administrator.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="campus-container animate-fade">
//       <div className="campus-grid">
//         {locations.map((loc, index) => (
//           <LocationCard
//             key={index}
//             loc={loc}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CampusInfo;


























import React, { useEffect, useState } from 'react';
import '../styles/CampusInfo.css';

const LOCATIONS = [
  {
    type: "Registered Office",
    address: "Plot No 5, Shri Gokul Society, Navi Peth, Sadashiv Peth, Pune, 411030.",
    region: "Pune, India",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.504746764516!2d73.83605907519129!3d18.506124582586224!2m3!1f0!2f0!3f0!3m2!1i1024!2i1024!4f13.1!3m3!1m2!1s0x3bc2bff356029025%3A0x3554dbb532013f77!2sSkyLine%20Enterprises!5e0!3m2!1sen!2sin!4v1709756000000!5m2!1sen!2sin",
    mapUrl: "https://www.google.com/maps?q=Sadashiv+Peth+Pune"
  },
  {
    type: "Headquarters GTE ONE",
    address: "Office #1401, S.No. 30, DNK SQUARE, Airport road, Sakore Nagar, Viman Nagar, Pune-411014.",
    region: "Maharashtra, India",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.316819323363!2d73.90418237519266!3d18.557674182544327!2m3!1f0!2f0!3f0!3m2!1i1024!2i1024!4f13.1!3m3!1m2!1s0x3bc2c127fe3f730b%3A0x7fbe51543d7f950a!2sDNK%20SQUARE%20by%20Dugad%20Group!5e0!3m2!1sen!2sin!4v1709756100000!5m2!1sen!2sin",
    mapUrl: "https://www.google.com/maps?q=DNK+SQUARE+Viman+Nagar+Pune"
  },
  {
    type: "Shivajinagar",
    address: "Sai Capital Building, 403, 4th Floor, Senapati Bapat Rd., Model Colony, Pune-411016.",
    region: "Pune, India",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.0076231904797!2d73.82772437519195!3d18.52857418257008!2m3!1f0!2f0!3f0!3m2!1i1024!2i1024!4f13.1!3m3!1m2!1s0x3bc2bf79e0b51c63%3A0xa0467142e87ec11e!2sSai%20Capital!5e0!3m2!1sen!2sin!4v1709756200000!5m2!1sen!2sin",
    mapUrl: "https://www.google.com/maps?q=Sai+Capital+Senapati+Bapat+Rd+Pune"
  },
  {
    type: "USA",
   address: `9498 SW Barbur Blvd.
Suite 207, 2nd Floor
Portland, OR 97219`,
    region: "Oregon, USA",
    embedUrl:
      "https://maps.google.com/maps?q=9498%20SW%20Barbur%20Blvd%20Portland%20OR%2097219&z=15&output=embed",
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=9498+SW+Barbur+Blvd+Portland+OR+97219",
  }
];

const LocationCard = ({ loc }) => (
  <div className="campus-card glass-morph">
    <div className="card-header">
      <h3 className="office-title">{loc.type}</h3>
    </div>

    <div className="map-embed-frame">
      <iframe
        src={loc.embedUrl}
        width="100%"
        height="200"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        title={`Map for ${loc.type}`}
      />
    </div>

    <div className="card-content">
      <div className="address-box">
        <span className="label">OFFICE ADDRESS:</span>
        <p className="address-text">{loc.address}</p>
      </div>

      <div className="card-footer">
        <span className="region-tag">{loc.region}</span>

        <a
          href={loc.mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="location-btn"
          style={{ textDecoration: 'none' }}
        >
          <span className="loc-icon">📍</span>
          <span className="btn-text">NAVIGATE</span>
        </a>
      </div>
    </div>
  </div>
);

const CampusInfo = ({ userData }) => {

  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const email = (
      userData?.EmailId ||
      userData?.email ||
      ""
    ).toLowerCase();

    const isGenesis =
      email.includes("genesistech.co.in") ||
      email.includes("gtecorpgroup.com") ||
      email.includes("gtcorpgroup.com");

    console.log("Campus Email:", email);
    console.log("Is Genesis:", isGenesis);

    if (isGenesis) {
      setLocations(LOCATIONS);
      setLoading(false);
      return;
    }

    fetch("/gt-api/get_company_locations.php", {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {

        console.log("Campus API:", data);

        if (data.success) {

          const formatted = (data.locations || []).map(loc => ({
            type: loc.office_type,
            address: loc.address,
            region: loc.region,
            embedUrl: loc.embed_url,
            mapUrl: loc.map_url
          }));

          setLocations(formatted);
        }
      })
      .catch(err => {
        console.error("Campus Fetch Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });

  }, [userData]);

  if (loading) {
    return (
      <div className="campus-container animate-fade">
        <h3 style={{ textAlign: "center" }}>
          Loading Campus Information...
        </h3>
      </div>
    );
  }

  if (locations.length === 0) {
    return (
      <div className="campus-container animate-fade">
        <div
          style={{
            textAlign: "center",
            padding: "60px",
            opacity: 0.7
          }}
        >
          <h3>No Campus Information Available</h3>
          <p>Please contact your administrator.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="campus-container animate-fade">
      <div className="campus-grid">
        {locations.map((loc, index) => (
          <LocationCard
            key={index}
            loc={loc}
          />
        ))}
      </div>
    </div>
  );
};

export default CampusInfo;